module.exports = __webpack_public_path__ + "media/images/bondform_bear1-7deb13eea54eeeeb598e87cdfdf9c7c2.gif";